export const sidePanelTransitionTimeInSeconds = 0.2
